import {MutableRefObject, useRef} from 'react';

function useElementScope<T extends Element | null>(
  passedElementRef?: MutableRefObject<T>,
) {
  const elementRef = useRef<T>(null);
  const elDocument = (passedElementRef || elementRef)?.current?.ownerDocument;
  const elWindow = elDocument?.defaultView || window;

  return {
    elementRef,
    elDocument,
    elWindow,
  };
}

export {useElementScope};
